<div class="auto-redeem-dialog ups-dialog" tabindex="0">
    <h2 *ngIf="title" [ngClass]="titleClass" mat-dialog-title><span class="title-span">{{ title }}</span> Auto-Redeem
        Points</h2>
    <div class="key-key"></div>
    <mat-dialog-content>
        <div [innerHtml]="message" class="dialog-content {{ messageClass }}"></div>
    </mat-dialog-content>

    <mat-dialog-actions>
        <button (click)="clickedYes()" [mat-dialog-close]="true" mat-raised-button>
            <span class="button-label">
                <span>{{yesMessage}}</span>
                <mat-icon>chevron_right</mat-icon>
            </span>
        </button>
        <button (click)="clickedNo()" class="alternative-button" mat-dialog-close mat-raised-button>
            <span class="button-label">
                <span>{{noMessage}}</span>
                <mat-icon>chevron_right</mat-icon>
            </span>
        </button>
    </mat-dialog-actions>

    <button class="icon-button close-button" mat-dialog-close mat-raised-button type="button">
        <mat-icon>close</mat-icon>
    </button>
</div>
